import { NameValuePair } from "@zickko/shared";
import { useEffect, useState } from "react";
import { DocumentRepo } from "../repo/DocumentRepo";
import { toastStore } from "../utils/toastStore";
import { useDeepDeps } from "../utils/useDeepDeps";

type Return<T> = {
  value: T | null | undefined;
  refreshFn: () => void;
};

export const useDocumentGet = <K extends NameValuePair<string>, T>(
  documentRepo: DocumentRepo<K, T>,
  key: K
): Return<T | undefined | null> => {
  //
  const [value, setValue] = useState<T | null | undefined>(null);

  const refreshFn = () => {
    setValue(undefined);
    documentRepo
      .get(key)
      .then((doc) => {
        if (doc) {
          setValue(doc);
          return;
        }
        setValue(null);
      })
      .catch((e) => {
        console.error(e);
        toastStore.error(`Error loading document at path ${documentRepo.path(key)}`);
      });
  };

  useEffect(() => {
    refreshFn();
  }, useDeepDeps([key]));

  return { value, refreshFn };
};
